export default __webpack_public_path__ + "164a0c5ed88eaffc786fc0278c2f7a0a.svg";